import React, { useState, useEffect } from 'react';
import logger from '../../../utils/logger';
import NosotrosBioMercy from './NosotrosBioMercy';

const NosotrosController = ({ initialSection = 'quienes' }) => {
  const [activeSection, setActiveSection] = useState(initialSection);

  // NUEVO: useEffect para sincronizar con initialSection cuando cambie
  useEffect(() => {
    logger.debug(
      'NosotrosController: initialSection changed to:',
      initialSection
    );
    setActiveSection(initialSection);
  }, [initialSection]);

  // Maneja clic en las pestañas del dropdown
  // const handleTabClick = (tab) => {
  //   // console.log("NosotrosController: Tab clicked:", tab);
  //   // console.log("NosotrosController: Changing from", activeSection, "to", tab);
  //   setActiveSection(tab); // 'quienes' o 'vision'
  // };

  // Debug para ver el estado actual
  // console.log("NosotrosController: Current activeSection:", activeSection);

  return (
    <div>
      {/* Dropdown de Nosotros */}
      {/* <NosotrosDropdown
        visible={false} // O controla visibilidad según necesites
        activeTab={activeSection}
        onTabClick={handleTabClick}
      /> */}

      {/* Contenido de Nosotros */}
      <NosotrosBioMercy activeSection={activeSection} />
    </div>
  );
};

export default NosotrosController;
